import LocationBulkDetails from "./LocationBulkDetails";

export default LocationBulkDetails;